import { Fragment, useEffect, useState } from 'react'
import {t} from 'i18next';
import { Navigate as Redirect, useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil'
import axios from 'axios';
import { Container, Card, CardBody, Row, Col } from 'reactstrap'

import env from '../../env/src_config';
import { headersState, tokenState } from '../../recoil/recoil';
import { isNull } from '../../izUtils';
import { axiosError, errorStatus } from '../../helpers/response';
import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb';
import ImportRows from '../../components/contracts/import/ImportRows';

const apiUrl = env.api + '/api/contract_import';

const ContractImportCompare = () => {
    const Navigate = useNavigate();
    const { importId } = useParams();
    const headers = useRecoilValue(headersState);
    const tokenData = useRecoilValue(tokenState);
    const isAdmin = tokenData.parsedToken.type === 'admin';

    const [importData, setImportData] = useState(null)

    useEffect(() => {
        if (!isAdmin) return;

        axios.get(apiUrl + '/' + importId, {headers}).then(response => {
            if (response.data.state === 'success') {
                setImportData(response.data.import);
            } else {
                errorStatus(response.data, t);
            }
        }).catch(error => axiosError(error, Navigate));
    }, [importId]) // eslint-disable-line react-hooks/exhaustive-deps

    if (!isAdmin) {
        return <Redirect to="/contracts" replace />
    }

    return (
        <Fragment>
            <Breadcrumbs parent={t('contracts.import.title')} title={t('contracts.import.compare.title')} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {!isNull(importData) &&
                                    <>
                                        <h5>{importData.file_name}</h5>
                                        <p className="small text-muted">{t('contracts.import.compare.note')}</p>
                                        <ImportRows importData={importData} apiUrl={apiUrl} />
                                    </>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default ContractImportCompare
